/**
 * Historial de la ficha del trabajo (Fase 1 trabajo manual): formateo PURO de
 * las entradas del AuditLog (`metadataJson.changes`) para el panel.
 */

const FIELD_LABELS: Record<string, string> = {
  descripcion: 'Descripción',
  direccion: 'Dirección',
  zona: 'Zona',
  notas: 'Notas',
  scheduledAt: 'Cita',
  tecnico: 'Técnico',
  esGarantia: 'Garantía',
  targetLat: 'Geocerca (lat)',
  targetLng: 'Geocerca (lng)',
  geofenceRadiusM: 'Geocerca (radio m)',
  mapsUrl: 'Link de Maps',
};

/** Etiqueta legible del campo; desconocido → tal cual (tolerante a nuevos). */
export function historyFieldLabel(campo: string): string {
  return FIELD_LABELS[campo] ?? campo;
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/;

/** Valor legible: null → raya, booleanos → Sí/No, ISO → fecha local. */
export function historyValueLabel(valor: unknown): string {
  if (valor === null || valor === undefined || valor === '') return '—';
  if (valor === true) return 'Sí';
  if (valor === false) return 'No';
  if (typeof valor === 'string' && ISO_DATE.test(valor)) {
    const d = new Date(valor);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleString('es-DO', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      });
    }
  }
  return String(valor);
}

const ACTION_LABELS: Record<string, string> = {
  'job.update': 'Edición de ficha',
  'job.assign': 'Asignación de técnico',
  'job.warranty': 'Garantía',
  'job.target': 'Geocerca',
  'job.despacho': 'Ficha de despacho',
};

/** Etiqueta legible de la acción del historial; desconocida → tal cual. */
export function historyActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}
